module.exports = __webpack_public_path__ + "img/logo.bc0e0b4b.png";